import React from "react";
import Image from "next/image";
import Play from "@/public/icon/playButton.svg";
import VideoImg from "@/public/images/video.jpg";

const Video = ({ item }) => {
  return (
    <div className="videoCard">
      <iframe
        width="100%"
        height="450"
        src={`https://www.youtube.com/embed/${item?.video_link}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default Video;
